import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogProps,
  Button,
  Heading,
  Text,
  VStack,
} from '@chakra-ui/react';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

export type ConfirmPostDeletionDialogProps = {
  deletePost: () => void;
  isDescriptionDisabled?: boolean;
} & Omit<AlertDialogProps, 'children' | 'leastDestructiveRef'>;

export const ConfirmPostDeletionDialog: React.FC<
  ConfirmPostDeletionDialogProps
> = ({ deletePost, onClose, isDescriptionDisabled = true, ...rest }) => {
  const { t } = useTranslation(['feed']);
  const leastDestructiveRef = useRef(null);
  return (
    <AlertDialog
      isCentered
      onClose={onClose}
      leastDestructiveRef={leastDestructiveRef}
      {...rest}
    >
      <AlertDialogOverlay>
        <AlertDialogContent px={'8'} py={'6'} m={'7'}>
          <AlertDialogHeader p={0}>
            <Heading
              as={'h2'}
              size={'lg'}
              lineHeight={'8'}
              children={t('feed:heading.BeitragWirklichUnwiderruflichLoschen')}
            />
          </AlertDialogHeader>
          {!isDescriptionDisabled && (
            <AlertDialogBody px={0} pt={'2'} pb={0}>
              <Text>
                {t(
                  'feed:text.KundenDieDenContentBereitsGekauftHabenSehenIhnWeiterhin'
                )}
              </Text>
            </AlertDialogBody>
          )}

          <AlertDialogFooter p={0}>
            <VStack minH={'5.5rem'} w={'full'} spacing={'4'} pt={'8'}>
              <Button
                width={'full'}
                children={t('feed:button.BeitragLoschen')}
                onClick={deletePost}
                colorScheme={'red'}
              />
              <Button
                variant={'outline'}
                width={'full'}
                children={t('feed:button.Abbrechen')}
                onClick={onClose}
                ref={leastDestructiveRef}
              />
            </VStack>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
